export const ipv6 = {
  wip: "WIp",
  pdaddr: "PDAddr",
  sdaddr: "SDAddr",
  ipv6_interface_id: "IPv6_interface_id",
  ipv6_6rd_pre: "prefix_hex",
  ipv6_pre_len: "prefix_len",
  relay_addr: "BRIp",
  ipv6_mask_len: "masklen",
  ipv6wanaddr: "IPv6WanAddr",
  ipv6gateway: "IPv6Gateway",
  ipv6_lan: "IPv6LanAddr",
  ipv6_lan_prefix: "ProfixLanLength",
  pppoe_servername: "pppoe_servicename",
};

export default ipv6;
